/**
 * 应用配置文件
 * 用于控制应用的全局配置项
 */

export const appConfig = {
  // 是否显示临时首页
  showTempHomePage: false,
  
  // 临时首页配置
  tempHomePage: {
    platformUrl: 'erp.shangzhanyun.com',
    title: '商栈平台'
  }
};

export default appConfig;
